import { PopoverHeader as _PopoverHeader, PopoverHeaderProps as _PopoverHeaderProps } from "reactstrap";

    export const PopoverHeader = _PopoverHeader;
    export type PopoverHeaderProps = _PopoverHeaderProps;
    